import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditEquipModa = ({ isOpen, onClose, editFormData, setEditFormData }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleEditSubmit = async (e) => {
    e.preventDefault();

        if (!editFormData.equip || editFormData.equip.trim() === "") {
            Swal.fire({
              icon: "warning",
              title: "Empty Field",
              text: "Please enter Equipment Type!",
            });
            return;
          }
        
      

    try {
        Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
      const response = await axios.put(`https://rfs2.infraconsoft.net.in/api/edit_equip/${editFormData.id}`, {
        equip: editFormData.equip,
        id : editFormData.id,
      });

     
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Equipment Updated successfully.",
        });
        onClose();
        window.location.reload();
      } else {
        console.warn("Insert failed, no 'success' in response:", response.data);
        Swal.fire({
          icon: "error",
          title: "Insert Failed",
          text: response.data.message || "Unknown error.",
        });
      }
      
    } catch (error) {
          console.error("Error inserting location:", error);
        
          if (error.response && error.response.data && error.response.data.message) {
            Swal.fire({
              icon: "error",
              title: "Insert Failed",
              text: error.response.data.message,  // <-- duplicate message will show here
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Insert failed. Please try again.",
            });
          }
        }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onClose} style={{position: "initial"}}>&times;</button>
    </div>
        <h3>Edit Vehicle Equipment Type</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Vehicle Equipment Type :</label>
                <input type="text" name="equip" value={editFormData.equip} onChange={handleEditChange} />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditEquipModa;
